// @flow
import EventList from 'components/event/EventList';
import { connect } from 'react-redux';
import type { DispatchType, StateType } from 'types/Actions';
import type { StateProps, DispatchProps } from 'components/event/EventList';
import { fetchArticlesCategory } from 'actions/newsletterCategoryActions';

import { fetchEvents } from 'actions/eventsActions';

export default connect(
  (state: StateType): StateProps => ({
    ligue: state.settingsState.ligue,
    events: state.eventsState.events,
    status: state.eventsState.status,
    articles: state.newsletterCategoryState.articles
  }),
  (dispatch: DispatchType): DispatchProps => ({
    fetchEvents: (from: Date, to: Date) => dispatch(fetchEvents(from, to)),
    fetchLigueArticles: () => dispatch(fetchArticlesCategory(1, 4, 'ligue'))
  })
)(EventList);
